import { Injectable } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';

@Injectable({ providedIn: 'root' })
export class ProductSelectionService {
    constructor(private upgrade: UpgradeModule) {}

    public selectSize(keyno: string): void {
        const search: ProductSizeSelectionClient = this.upgrade.$injector.get('searchService');
        search.prodsize.selected = true;
        search.prodsize.selectedProdsizeKeyno = keyno;
    }

    public selectChoice(selection: ProductChoiceSelection): void {
        // The legacy order-line editor reads this shared result when the selector returns.
        const search: ProductChoiceSelectionClient = this.upgrade.$injector.get('searchService');
        search.prodChoiceSelected = selection;
    }
}

export interface ProductChoiceSelection {
    prod_id: string;
    prod_name: string;
    choice_keyno: string;
}

interface ProductChoiceSelectionClient {
    prodChoiceSelected?: ProductChoiceSelection;
}

interface ProductSizeSelectionClient {
    prodsize: { selected: boolean; selectedProdsizeKeyno: string };
}
